<template>
  <div class="kpArticle_show">
    <div class="kpArticle_center">
      <div class="center_left">
        <div class="kpArticle_title">
          <div class="left_head">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>高血压的十大谣言，你应该知道！</div>
          </div>
          <div class="time_box">2019-11-16</div>
        </div>
        <div class="kpArticle_text">
          <p>“造谣一张嘴，辟谣跑断腿”，在10月22日召开的全国高血压防治宣传日主题活动上，北京大学人民医院主任医师张海澄为“十个高血压谣言”辟谣。 这些谣言根据腾讯较真、腾讯新闻、有腾讯指数、QQ空间、微博、新闻报道等梳理出来的。 据腾讯指数10月22日公布的大数据显示，自今年5月17日世界高血压日后，6-8月高血压的相关信息网络传播总量超过500万条，高血压相关文章接近2000篇，2400余万阅读量，超过4.8万的评论数</p>
          <img src="../../assets/images/home/ceshi1.jpeg" alt="">
          <h1 style="margin: 20px 0">谣言一：偏方言一高血压 <br></h1>
          <p> 在网络上，有上千万的点击量关注偏方治疗高血压，在各网络平台，包括微信、微博上面有很多各种各样的偏方，比如“治疗高血压27个绝密的偏方”，“三个绝世的秘方”等。 这些谣言包括花生壳、芥末煮水、芝麻酱等可治高血压，这究竟是针对个人有效还是群体有效？ 张海澄说，“我们要相信循证医学，要有随机双盲研究、流行病学的研究”。另外，验证一个治疗方案，首先要保证安全。而这些偏方没有经过科学证实。张海澄说，高血压可防可治，得得了高血压并不是多么大的事。不要把偏方当做唯一的救命稻草，还是需要到正规医院找医生来治疗，听从医生的预防用药建议。健康生活方式对血压的治疗和防控最有效。</p>
          <h1 style="margin: 20px 0">谣言二：益母草能降血压 <br></h1>
          <p> 在今年6-9月的三个月里，数据显示关于益母草能降高血压的关注度近300多条。 目前，小型动物实验中，用益母草水煎服7天后血压平均降幅约3，服药2周后血压降在10以内。 目前有研究证明，益母草的提取物益母草碱液每公斤120毫克静脉给药，对血压有作用。如果按照这个实验剂量来服用益母草，就算个体吸收率是100%，一个体重50公斤的女性，每天用益母草碱液，每天需要至少50毫克以上的益母草，而中国药典规定益母草每天的上限是30克。所以用益母草降血压并不靠谱，何况动物实验的结果和在人身上用药相距甚远。</p>
        </div>
      </div>
      <div class="center_right">
        <div class="hebdomad_box">
          <div class="hebdomad">一周热点</div>
          <div class="disease_card_right">
            <div class="item_list">
              <div class="item_GraphicText_list">
                <div class="GraphicImg">
                  <img src="../../assets/images/home/jibing3.jpeg" alt="">
                </div>
                <div class="textTime">
                  <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                  <span>2020-03-12</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="item_GraphicText_list">
                <div class="GraphicImg">
                  <img src="../../assets/images/home/jibing3.jpeg" alt="">
                </div>
                <div class="textTime">
                  <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                  <span>2020-03-12</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="item_GraphicText_list">
                <div class="GraphicImg">
                  <img src="../../assets/images/home/jibing3.jpeg" alt="">
                </div>
                <div class="textTime">
                  <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                  <span>2020-03-12</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="item_GraphicText_list">
                <div class="GraphicImg">
                  <img src="../../assets/images/home/jibing3.jpeg" alt="">
                </div>
                <div class="textTime">
                  <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                  <span>2020-03-12</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="item_GraphicText_list">
                <div class="GraphicImg">
                  <img src="../../assets/images/home/jibing3.jpeg" alt="">
                </div>
                <div class="textTime">
                  <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                  <span>2020-03-12</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="item_GraphicText_list">
                <div class="GraphicImg">
                  <img src="../../assets/images/home/jibing3.jpeg" alt="">
                </div>
                <div class="textTime">
                  <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                  <span>2020-03-12</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Show"
  }
</script>
<style lang="stylus" scoped>
  .kpArticle_show{
    margin-top 30px
    .kpArticle_center{
      width: 1200px
      margin 0 auto
      display flex
      justify-content space-between
      .center_left{
        width: 811px
        .kpArticle_title{
          display flex
          justify-content space-between
          position relative
          flex-wrap wrap
          &:after{
            content ''
            display block
            width: 100%
            height: 1px
            background #e7e7e7
            margin 20px 0 30px 0
          }
          .left_head{
            width: 100%
            display flex
            align-items center
            >img{
              width: 120px
              height: 90px
              margin-right 10px
            }
            >div{
              font-weight: 700;
              font-size: 20px;
              color: #333
              width: 70%
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .time_box{
            font-size: 12px;
            color: #C9C9C9;
            position absolute
            right 20px
            bottom 50px
          }
        }
        .kpArticle_text{
          >p{
            font-size: 16px;
            line-height: 28px;
            color: #333
            text-indent 2em
          }
          >img{
            max-width 100%
          }
        }
      }
      .center_right{
        width: 361px
        .hebdomad_box{
          .hebdomad{
            font-weight: 700;
            font-size: 20px;
            color: #333
            margin-bottom 30px
          }
          .disease_card_right{
            margin-top 10px
            width:361px
            .item_list{
              display flex
              flex-wrap wrap
              flex 1
              &:after{
                content: ''
                display block
                width: 100%
                height: 1px
                border-top 1px dashed #e7e7e7
                margin 15px 0
              }
              &:last-child{
                &:after{
                  display none
                }
              }
              .item_GraphicText_list{
                display flex
                .GraphicImg{
                  >img{
                    width: 100px
                    height: 70px
                    margin-right 15px
                  }
                }
                .textTime{
                  height: 70px
                  display flex
                  flex-direction column
                  justify-content space-around
                  >div{
                    color: #5E5E5E
                    font-size 14px
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    line-height 18px
                  }
                  >span{
                    color: #868686
                    font-size 12px
                    text-align: right
                    margin-top 10px
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/kpArticle/Show.vue